import React from 'react'

interface IModalUiProps {
  children?: React.ReactNode
}

interface IModalUiReturn {
  UiModal: React.FC<IModalUiProps>
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const UseModalWithChildrenUi = (): IModalUiReturn => {
  const [isOpen, setIsOpen] = React.useState(false)

  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)

  const UiModal: React.FC<IModalUiProps> = (props) => (
    <div
      className={`fixed inset-0 z-[999] flex items-center justify-center ${isOpen ? 'block' : 'hidden'}`}
    >
      <div
        className='absolute inset-0 bg-black bg-opacity-40 backdrop-blur-sm'
        onClick={onClose}
      />
      <div className='relative w-80 rounded-lg bg-esforce-black-350 p-5 shadow-md'>
        {props.children}
      </div>
    </div>
  )

  return { UiModal, isOpen, onOpen, onClose }
}
